import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SaveSimulationForm, toSimulationNodeData } from '../../../shared/components/header-modals/save-simulation-modal/save-simulation-modal.component';
import { UnitSystem } from '../../../shared/enums/unit-system.enum';

@Injectable({
  providedIn: 'root'
})
export class AdvancedpipeService {

  // Unit system communication
  private unitSystemSource$ = new BehaviorSubject<UnitSystem>(UnitSystem.USC);
  unitSystem$ = this.unitSystemSource$.asObservable();

  // DCP Product communication for modal
  private dcpProductSource$: Subject<any> = new Subject<any>();
  dcpProduct$ = this.dcpProductSource$.asObservable();

  private closeDcpModalSource$: Subject<boolean> = new Subject<boolean>();
  closeDcpModal$ = this.closeDcpModalSource$.asObservable();

  constructor(private httpClient: HttpClient) {}

  // Unit system methods
  setUnitSystem(unit: UnitSystem) {
    this.unitSystemSource$.next(unit);
  }

  getUnitSystem(): UnitSystem {
    return this.unitSystemSource$.getValue();
  }

  // DCP Product methods for modal communication
  setDcpProduct(dcpProduct: any) {
    this.dcpProductSource$.next(dcpProduct);
  }

  setCloseDcpModal(closeDcpModal: boolean) {
    this.closeDcpModalSource$.next(closeDcpModal);
  }

  saveSimulation(formData: any, saveSimulationForm: any): Observable<any> {
    const url = `${environment.apiEndpoint}advanced-pipe-ratings/v1/advanced-pipe-ratings/save`;
    const body = JSON.stringify({
      ...formData,
      simulationNodeData: toSimulationNodeData(saveSimulationForm)
    });
    return this.httpClient.post(url, body, {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  // Load a saved simulation by treeId (accepts number/string or nested objects)
  loadSimulation(treeRef: number | string | any): Observable<any> {
    const url = `${environment.apiEndpoint}advanced-pipe-ratings/v1/advanced-pipe-ratings/get`;
    // Normalize to the numeric simulation id expected by the API
    let treeId: number | string | undefined = undefined;
    if (treeRef == null) {
      treeId = undefined;
    } else if (typeof treeRef === 'number' || typeof treeRef === 'string') {
      treeId = treeRef as number | string;
    }
    const body = JSON.stringify({ treeId });
    return this.httpClient.post(url, body, {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  calculate(request: any): Observable<any> {
    const url = `${environment.apiEndpoint}advanced-pipe-ratings/v1/advanced-pipe-ratings/calculate`;
    return this.httpClient.post(url, JSON.stringify(request), {
      headers: { 'Content-Type': 'application/json' }
    });
  }
}